export default __webpack_public_path__ + "static/media/sao-paulo.ba03e8c2.png";